import { ifProp, theme } from 'styled-tools';

import Arrow from '../icons/Arrow';
import Link from 'next/link';
import React from 'react';
import prepInternalUrl from '../../../lib/prepInternalUrl';
import { rem } from 'polished';
import styled from 'styled-components';

const StyledButton = styled.a`
  display: inline-block;
  color: ${theme('colors.white')};
  background-color: ${theme('colors.orange')};
  border: 2px solid ${theme('colors.orange')};
  font-size: ${rem(18)};
  font-weight: 700;
  text-transform: uppercase;
  user-select: none;
  padding: 0.5em 1em 0.5em 1em;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-sizing: border-box;

  :hover {
    color: ${theme('colors.orange')};
    background: transparent;
  }
  :active {
    color: ${theme('colors.white')};
    background: ${theme('colors.altOrange')};
  }

  &.cta-primary {
    color: ${theme('colors.orange')};
    background-color: transparent;
    border: 2px solid ${theme('colors.orange')};

    :hover {
      color: ${theme('colors.blue')};
      border-color: ${theme('colors.blue')};
    }
    :active {
      color: ${theme('colors.blue')};
      border-color: ${theme('colors.blue')};
    }
  }
  &.cta-secondary {
    color: ${theme('colors.white')};
    background-color: transparent;
    border: 2px solid ${theme('colors.white')};

    :hover {
      color: ${theme('colors.orange')};
      border-color: ${theme('colors.orange')};
    }
    :active {
      color: ${theme('colors.orange')};
      border-color: ${theme('colors.orange')};
    }
  }
  &.cta-shadow {
    color: ${theme('colors.orange')};
    background-color: ${theme('colors.white')};
    border: 2px solid ${theme('colors.baseOrange')};
    box-shadow: 10px 10px 0px 0px #ffa97e;

    :hover {
      box-shadow: 15px 15px 0px 0px #ffa97e;
    }
    :active {
      box-shadow: 15px 15px 0px 0px #ffa97e;
    }
  }

  &.cta-filled {
    &.cta-primary {
      color: ${theme('colors.white')};
      background-color: ${theme('colors.orange')};
      border: 2px solid ${theme('colors.orange')};

      :hover {
        color: ${theme('colors.orange')};
        background: transparent;
      }
      :active {
        color: ${theme('colors.white')};
        background: ${theme('colors.altOrange')};
      }
    }
    &.cta-secondary {
      color: ${theme('colors.white')};
      background-color: ${theme('colors.blue')};
      border: 2px solid ${theme('colors.blue')};

      :hover {
        color: ${theme('colors.blue')};
        background: transparent;
      }
      :active {
        color: ${theme('colors.white')};
        background: ${theme('colors.blue')};
      }
    }
  }
`;

const StyledLink = styled.a<{ hoverMode: string }>`
  color: ${theme('colors.orange')};
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;
  :hover {
    color: ${ifProp({ hoverMode: 'light' }, theme('colors.white'), theme('colors.blue'))};
    svg,
    path {
      fill: ${ifProp({ hoverMode: 'light' }, theme('colors.white'), theme('colors.blue'))};
      stroke: ${ifProp({ hoverMode: 'light' }, theme('colors.white'), theme('colors.blue'))};
    }
  }
`;
interface CtaProps {
  children: React.ReactNode;
  to?: string;
  type?: string;
  hoverMode?: string;
  className?: string;
  'aria-label'?: string;
}

const Cta: React.FC<CtaProps> = ({ children, to, type, hoverMode, ...props }) => {
  const url = prepInternalUrl(to);
  if (!url) return null;
  if (url.startsWith('/')) {
    return type === 'link' ? (
      <Link href={url} passHref legacyBehavior>
        <StyledLink hoverMode={hoverMode} {...props}>
          <>
            {children}
            <Arrow style={{ marginLeft: '15px' }} />
          </>
        </StyledLink>
      </Link>
    ) : (
      <Link href={url} passHref legacyBehavior>
        <StyledButton {...props}>{children}</StyledButton>
      </Link>
    );
  }

  return (
    <StyledButton
      // as={OutboundLink}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      {...props}
    >
      {children}
    </StyledButton>
  );
};

export default Cta;
